import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import Api from "../../shared/api/api";

const MediaContext = createContext(null);
export function MediaProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    setError("");
    try {
      const data = await Api.request("api/media/settings");
      setConfig(data.config);
      return data.config;
    } catch {
      setError("Page settings could not be loaded. Please try again.");
      return null;
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const value = useMemo(() => ({ config, setConfig, loading, error, refresh }), [config, loading, error, refresh]);
  return <MediaContext.Provider value={value}>{children}</MediaContext.Provider>;
}
export function useMedia() {
  const context = useContext(MediaContext);
  if (!context) throw new Error("useMedia must be used within MediaProvider.");
  return context;
}
